import * as React from "react";
import { useState, useEffect } from "react";
import classNames from "classnames";
import { UnmountClosed } from "react-collapse";
import AriaTooltip from "../../applications/Shared/Tooltip/AriaTooltip";
import { Guid } from "../Utils/Guid";

export interface IAccordionProps {
    label: string;
    onEdit?: VoidFunction;
    onRemove?: VoidFunction;
    onChange?: (v: boolean) => boolean;
    toolTip?: string;
    children?: any;
    cssWrapper?: any;
    iconCss?: any;
    isOpen?: boolean;
    unableToExpand?: boolean;
}

export const Accordion = (props: IAccordionProps) => {
    const { label } = props;
    const { onEdit, onRemove } = props;
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    const ToggleDropdown = () => {
        if (props.unableToExpand != null && props.unableToExpand == true) {return;}
        if (!props.onChange || props.onChange(!isOpen)) {
            setIsOpen(!isOpen);
        }
    };

    const CSSclassNames = classNames("accordion", props.cssWrapper, {
        "is-open": isOpen,
    });

    const accordionButtonId = Guid.getNext();
    const accordionContentId = Guid.getNext();

    return (
        <div className={CSSclassNames}>
            <div className="accordion-row">
                <div className="left-side">


                    <button onClick={() => ToggleDropdown()} id={accordionButtonId} aria-controls={accordionContentId} aria-expanded={isOpen} className="trigger">
                        {(props.unableToExpand == null || props.unableToExpand != true) && (
                            <span className={classNames("icon", props.iconCss)} onClick={() => ToggleDropdown()} aria-hidden="true"></span>
                        )}
                        <span className="title">{label}</span>
                    </button>
                    {props.cssWrapper == "accordion-simple" && (
                        <div className="inline-block">
                            {props.toolTip && (
                                <AriaTooltip cssWrapper="is-info-icon" showCloseButton={true}>
                                    {props.toolTip}
                                </AriaTooltip>
                            )}
                        </div>
                    )}
                </div>
                <div className="right-side">
                    {onEdit && (
                        <button className="edit-circle-icon-button label-sr-only" title="Edit" onClick={() => onEdit()}>
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Edit</span>
                        </button>
                    )}
                    {onRemove && (
                        <button className="circle-remove-button" onClick={() => onRemove()}>
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Remove this {label}</span>
                        </button>
                    )}
                </div>
            </div>
            <UnmountClosed isOpened={isOpen}>
                <div className="expanded" id={accordionContentId}>{props.children}</div>
            </UnmountClosed>
        </div>
    );
};
